/**
 * NIKA: разделителите в размерните легенди — точно по средата между края
 * на единия размер и началото на следващия (текстовете са различно широки
 * и фиксирана позиция изглежда изместена). Ползва се от sibling picker-а
 * (кутии/профили) и от легендата на колелата (variant picker).
 */
(function () {
  if (window.__nikaDimsDividers) return;
  window.__nikaDimsDividers = true;

  var position = function () {
    document.querySelectorAll('.nika-dims-legend__grid').forEach(function (grid) {
      var cells = grid.querySelectorAll('.nika-dims-legend__cell');
      for (var i = 1; i < cells.length; i++) {
        var prev = cells[i - 1];
        var cur = cells[i];
        var prevRight = 0;
        prev.querySelectorAll('.nika-dims-legend__label, .nika-dims-legend__val').forEach(function (n) {
          var r = n.getBoundingClientRect();
          if (r.right > prevRight) prevRight = r.right;
        });
        var curLeft = cur.getBoundingClientRect().left;
        if (!prevRight || prevRight >= curLeft) continue;
        var mid = (prevRight + curLeft) / 2;
        cur.style.setProperty('--nika-div-x', (mid - curLeft) + 'px');
      }
    });
  };
  position();
  window.addEventListener('load', function () { position(); setTimeout(position, 400); });
  window.addEventListener('resize', position);
  /* легендите се морфват при смяна на вариант — премери пак (пише само
     стилова променлива, observer-ът не следи атрибути → няма цикъл) */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t.nodeType === 1 && t.closest && t.closest('.nika-dims-legend')) { position(); return; }
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
